export default __webpack_public_path__ + "static/media/newmexico.830bbcbc.jpg";